import { Component, Optional, Inject, Injector, OnInit, AfterViewInit, OnDestroy, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    NG_ASYNC_VALIDATORS,
    UntypedFormControl,
} from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-with-prefix',
    templateUrl: './input-with-prefix.component.html',
    styleUrls: [
        './input-with-prefix.component.scss',
        '../input.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputWithPrefixComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => InputWithPrefixComponent),
            multi: true,
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputWithPrefixComponent extends InputBase<string> implements OnInit, AfterViewInit, OnDestroy
{
    // RFC 2822 compliant regex
    // * https://regexr.com/4lntt
    private static alphabeticRegexp = /^[-a-z0-9]*$/;
    private static identifier: number = 0;

    @Input() prefix: string;

    constructor(
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        injector: Injector
    )
    {
        super(injector);

        this.fieldId = `input-with-prefix-${InputWithPrefixComponent.identifier++}-id`;
    }

    ngOnInit (): void
    {
    }

    ngAfterViewInit (): void
    {
    }

    ngOnDestroy ()
    {
    }

    // * https://netbasal.com/adding-integrated-validation-to-custom-form-controls-in-angular-dc55e49639ae
    validate ({ value }: UntypedFormControl)
    {
        if (value)
        {
            return value.match(InputWithPrefixComponent.alphabeticRegexp) ? null : { 'alphabetic': true };
        }
    }
}
